import type { Article, Heading } from '../types'

export const HEADING_BASE_DATA = {
  horizontal_designed: { type: 'designed', tagText: '[横凸]', title: 'カット見出し（横）' },
  vertical_designed: { type: 'designed', tagText: '[縦凸]', title: 'カット見出し（縦）' },
  top_covering: { type: 'top_covering', tagText: '[上被]', title: '上被せ' },
  pillar: { type: 'pillar', tagText: '[柱]', title: '柱見出し' },
  primary: { type: 'primary', tagText: '[主]', title: '主見出し' },
  secondary: { type: 'secondary', tagText: '[袖]', title: '袖見出し' },
  bottom_covering: { type: 'bottom_covering', tagText: '[下被]', title: '下被せ' },
  preamble: { type: 'preamble', tagText: '[前脇]', title: '前文脇見出し' }
}

type HeadingKey = keyof typeof HEADING_BASE_DATA

interface HeadingEntry {
  data: Heading | undefined
  base: { menuType: HeadingKey } & (typeof HEADING_BASE_DATA)[HeadingKey]
}

const buildHeadingsShape = (article: Article) => {
  const rawHeadings = article?.headings ?? []
  const headings = Object.entries(HEADING_BASE_DATA).reduce<Record<HeadingKey, HeadingEntry>>(
    (acc, [key, base]) => {
      const k = key as HeadingKey
      const heading = rawHeadings.find((h) => [h.headingType, `${h.orientation}_${h.headingType}`].includes(k))
      acc[k] = { data: heading, base: { menuType: k, ...base } }
      return acc
    },
    {} as Record<HeadingKey, HeadingEntry>
  )
  const headingOrientation =
    headings.pillar.data?.orientation ||
    headings.primary.data?.orientation ||
    headings.secondary.data?.orientation ||
    'vertical'
  const headingObjectStyleType =
    headings.pillar.data?.headingObjectStyleType ||
    headings.primary.data?.headingObjectStyleType ||
    headings.secondary.data?.headingObjectStyleType ||
    'heading'
  return { headings, headingOrientation, headingObjectStyleType }
}

export const buildInitialValues = (article: Article) => {
  const { headings, headingOrientation, headingObjectStyleType } = buildHeadingsShape(article)
  return {
    headings,
    rootHeading: {
      data: {
        headingCombinationSettingType: article.headingCombinationSettingType,
        numberOfOccupyingColumns: article.headingNumberOfOccupyingColumns,
        numberOfOccupyingRows: article.headingNumberOfOccupyingRows,
        numberOfOccupyingCharacters: null,
        headingOrientation,
        headingObjectStyleType
      }
    }
  }
}
